<template>
  <div id="app2">
    <Header isHome v-if="isApp" />
    <div class="app-con" v-if="isApp">
      <LeftSide />
      <router-view />
    </div>
    <!-- <div id="nav">
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link>
      </div> -->
    <router-view v-else />
    <!-- <component :is="currentComp" /> -->
    <SwitchOrg v-model="orgPopup" @mouseleave.stop @mouseenter.stop />
  </div>
</template>

<script>
import actions from '@/utils/actions'
import Header from '@/components/layout/components/Header.vue'
import SwitchOrg from '@/components/common2/switchOrg.vue'
// import App from '@/views/organization-manage'
// import Personal from '@/views/personal'
// import Demo from '@/views/Demo.vue'
// import Config from '@/components/layout'
// import Role from '@/views/role-permissions'
export default {
  name: "App",
  components: {
    Header,
    SwitchOrg
  },
  data() {
    return {
      orgPopup: false
    }
  },
  computed: {
    // 是否独立运行
    isApp() {
      return !window.__POWERED_BY_QIANKUN__
    }
  },
  created() {
    let token = sessionStorage.getItem('dG9rZW4=');
    // 获取当前用户权限码
    token && this.$api.role.getPermissionCodes().then((res) => {
      this.$store.commit('setTreeCode', res.data)
    })
  },
  mounted() {
    if (!this.isApp && this.$root.microType !== 'components') {
      let elements = document.querySelector('#container')?.childNodes
      let childrenNode = elements[0]
      childrenNode ? childrenNode.setAttribute('style', 'height:100%;width:100%') : ''
    // } else {
    }
    actions.onGlobalStateChange((state) => {
      state.showChangeOrgan && this.orgChange()
    })
  },
  methods: {
    orgChange() {
      this.orgPopup = true
    },
  }
}
</script>

<style lang="less" scoped>
:root {
  --theme-color: #456bd1;
  --theme-color-rgb: 69, 107, 209;
}

@import '//at.alicdn.com/t/c/font_2610038_mfurgrwvxlo.css';

#app2 {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 170px);
}

.app-con {
  width: 100%;
  height: calc(100vh - 65px);
  display: flex;

  .con_left_side {
    margin-right: 20px;
  }

  >div:last-child:not(.wrapper) {
    width: calc(100% - 250px);
    padding: 20px;
  }
}
</style>
